import memoizeOne from 'memoize-one';
import type { NodeComponentsProps } from '@atlaskit/renderer';
import { fg } from '@atlassian/jira-feature-gating';

const cardRendererNodes = importCond<
	typeof import('@atlaskit/renderer/experimental-sync-custom-nodes/cards'),
	typeof import('./emptyRendererNodeMapping.tsx')
>(
	'magma-3467-iv-renderer-sync-card-nodes',
	'@atlaskit/renderer/experimental-sync-custom-nodes/cards',
	'./emptyRendererNodeMapping.tsx',
);

const mediaRendererNodes = importCond<
	typeof import('@atlaskit/renderer/experimental-sync-custom-nodes/media'),
	typeof import('./emptyRendererNodeMapping2.tsx')
>(
	'magma-3467-iv-renderer-sync-media-nodes',
	'@atlaskit/renderer/experimental-sync-custom-nodes/media',
	'./emptyRendererNodeMapping2.tsx',
);

const smallRendererNodes = importCond<
	typeof import('@atlaskit/renderer/experimental-sync-custom-nodes/small-nodes'),
	typeof import('./emptyRendererNodeMapping3.tsx')
>(
	'magma-3467-iv-renderer-sync-small-nodes',
	'@atlaskit/renderer/experimental-sync-custom-nodes/small-nodes',
	'./emptyRendererNodeMapping3.tsx',
);

/**
 * BEWARE there is a server-file override for this, because conditional imports do not currently
 * work with Jira Bifrost SSR's import lifting: https://atlassian.slack.com/archives/C07SP6N4FD5/p1748336179411089
 *
 * that file needs to be updated with any changes to this file, too
 */
export const getSyncRendererNodeOverrides = memoizeOne(() => {
	let nodeOverrides: NodeComponentsProps = {};
	if (fg('magma-3467-iv-renderer-sync-card-nodes')) {
		nodeOverrides = { ...nodeOverrides, ...cardRendererNodes };
	}
	if (fg('magma-3467-iv-renderer-sync-media-nodes')) {
		nodeOverrides = { ...nodeOverrides, ...mediaRendererNodes };
	}
	if (fg('magma-3467-iv-renderer-sync-small-nodes')) {
		nodeOverrides = { ...nodeOverrides, ...smallRendererNodes };
	}
	return nodeOverrides;
});
